import BaseViz from './BaseViz'
import CandleStickChart from '../charts/CandleStickChart'
import CandleStickDataController from '../viz_behaviors/CandleStickDataController'
export default class CandleStickViz extends BaseViz {
  static defaultConfig = {
    LegendBehavior: {
      showLegend: {
        value: true,
        nonEditable: true,
      },
    },
    ItemsHelper: {
      colorScale: {
        nonEditable: true,
      },
      colorDict: {
        nonEditable: true,
      },
    },
    AxisHelper: {
      y: {
        trimThreshold: {
          nonEditable: true,
        },
      },
      x: {
        showTickValues: {
          nonEditable: true,
        },
        trimThreshold: {
          nonEditable: true,
        },
      },
      zoomAxes: ['x'],
    },
    TooltipBehavior: {
      getHtml: function (d) {
        return `<div> 
        open: ${this.valueWithUnit(d.open)}<br/>
        close: ${this.valueWithUnit(d.close)}<br/>
        low: ${this.valueWithUnit(d.low)}<br/>
        high: ${this.valueWithUnit(d.high)}</div>
        <div class="secondary">${d.id}</div>
        `
      },
    },
  }

  static chartClass = CandleStickChart
  static dataControllerClass = CandleStickDataController
}
